module.exports = __webpack_public_path__ + "img/down.a8f8fc3e.svg";